module.exports = __webpack_public_path__ + "static/media/COVER-FTM.05953049.png";